module.exports = __webpack_public_path__ + "img/samsung-galaxy-e5.05e7452d.png";